module.exports = __webpack_public_path__ + "static/converse-dee4e15fc7516bf5bfd84f37194fe2e0.png";